export const EXCMDEVICEPERIPHERALDEVICE_SHOW_RESET = 'EXCMDEVICEPERIPHERALDEVICE_SHOW_RESET'
export const EXCMDEVICEPERIPHERALDEVICE_SHOW_SET_ERROR = 'EXCMDEVICEPERIPHERALDEVICE_SHOW_SET_ERROR'
export const EXCMDEVICEPERIPHERALDEVICE_SHOW_SET_RETRIEVED = 'EXCMDEVICEPERIPHERALDEVICE_SHOW_SET_RETRIEVED'
export const EXCMDEVICEPERIPHERALDEVICE_SHOW_TOGGLE_LOADING = 'EXCMDEVICEPERIPHERALDEVICE_SHOW_TOGGLE_LOADING'
